// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"76d624d0","317":"f806bdf2","419":"e46f7c1d","492":"35b5360b","513":"26aa0971","703":"5278d873","734":"5d989a95","787":"1598ce61"}[chunkId] + ".chunk.js";
};